export default "__VITE_ASSET__C6Ayt5sb__"